// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CIPAPIConfig } from "src/app/shared/datasource/interfaces/CIP/cip-general.interface";
import { genericVars } from "./generic-variables";

export const environment = {
  appRegistrationPrefix: "T",
  userScopes: {
    scopes: ['User.ReadWrite'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  appScopes: {
    scopes: ['Application.ReadWrite.All'],
    uri: 'https://graph.microsoft.com/v1.0/application'
  },
  groupScopes: {
    scopes: ['Directory.Read.All'],
    uri: 'https://graph.microsoft.com/v1.0/groups'
  },
  jafarPortalScopes:{
    baseApp : {
      scopes: ['api://cba30df4-b89d-412f-b85e-e8de2165a691/.default'],
      uri: 'https://func-app-jafarportal-test.azurewebsites.net/api'
    },
    approvalProcess : {
      scopes: ['api://cba30df4-b89d-412f-b85e-e8de2165a691/.default'],
      uri: 'https://func-app-jafarportal-approvalprocess-test.azurewebsites.net/api'
    }
  },
  msalConfig: {
    auth: {
      clientId: '326fb894-0701-4074-a9fc-02e790b5bb03',
      authority: 'https://login.microsoftonline.com/a7710ec2-1dbb-4980-9379-65fee8028a40',
      redirectUri: `https://${window.location.host}/auth`
    }
  },
  azuretenant:"a7710ec2-1dbb-4980-9379-65fee8028a40",
  azureappid:"326fb894-0701-4074-a9fc-02e790b5bb03",
  consoleLogs: false,
  generic: genericVars,
  jeannieApiURL: 'https://app-connect-test.computacenter.com',
  jeannieEnvironment: "Test",
  production: false,
  toolbartitle: "User Experience Portal - Test",
  welcomemessage: "Welcome to the User Experience Portal - Testing",
};

export const azureFunctions = {
  portalFunctions : {
    baseUrl: "https://func-app-jafarportal-test.azurewebsites.net/api",
  },
  approvalFunctions : {
    baseUrl: "https://func-app-jafarportal-approvalprocess-test.azurewebsites.net/api",
  }
}

export const CIPSettings : CIPAPIConfig = {
  baseUrl         : "https://func-app-jafarportal-test.azurewebsites.net/api",
  endPoints       : {
    changes             : "CIPChanges",
    changeDetails       : "CIPChangeDetails",
    incidents           : "CIPIncidents",
    incidentDetails     : "CIPIncidentDetails",
    requests            : "CIPRequests",
    requestDetails      : "CIPRequestDetails",
    requestTasks        : "CIPRequestTasks",
    requestTaskDetails  : "CIPRequestTaskDetails",
    envRoute            : "CIPEnvRoute",
    envRouteDefault     : "CIPEnvRouteDefault"
  }
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
